import * as S from "@components/navbar/style/MobileNavbar.styled";
import { handleRemoveToken } from "@entities/auth";
import { INavMenu, IUser } from "@types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useMobileMenu } from "@components/navbar/lib/useMobileMenu";
import { NavbarHeader } from "@components/navbar/ui/mobile/NavbarHeader";
import { Sidebar } from "@components/navbar/ui/mobile/Sidebar";
import useAuth from "@hooks/useAuth";

interface MobileNavbarProps {
  user: IUser | null;
  navMenuItems: INavMenu | null;
}

const MobileNavbar: React.FC<MobileNavbarProps> = ({ user, navMenuItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setAuth }: any = useAuth();

  const { openMenus, toggleMenu } = useMobileMenu(navMenuItems?.navbar || []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(handleRemoveToken());
    setAuth(undefined);
    navigate("/login");
    setIsOpen(false);
  };

  if (!navMenuItems) return null;

  return (
    <S.MobileNav>
      <NavbarHeader
        user={user}
        isOpen={isOpen}
        onToggleMenu={() => setIsOpen(true)}
        onCloseMenu={() => setIsOpen(false)}
      />

      <S.SidebarOverlay $open={isOpen} onClick={() => setIsOpen(false)} />
      <Sidebar
        user={user}
        navItems={navMenuItems.navbar}
        openMenus={openMenus}
        toggleMenu={toggleMenu}
        onCloseMenu={() => setIsOpen(false)}
        onLogout={handleLogout}
        isOpen={isOpen}
        pathname={pathname}
      />
    </S.MobileNav>
  );
};

export default MobileNavbar;
